<template>
  <div class="wrap">
    <div class="box">
      <div class="box_title">
        <h2>회원 전환</h2>
      </div>
      <div class="join_check check_all">
        <div class="text_label">
          <label
            ><input
              v-model="checkedAll"
              type="checkbox"
              name="agree"
              class="check_agree"
              @click="checkAll"
            /><em></em
            ><span>
              <strong>{{ $t('views.auth.join.joinstep1.5911') }}</strong></span
            ></label
          >
        </div>
      </div>
      <!-- </div>
    <div class="box"> -->
      <ul class="join_check">
        <li>
          <div class="text_label">
            <label>
              <input
                v-model="agreedTerms"
                value="termsOfUse"
                type="checkbox"
                name="agree"
                class="check_agree"
              />
              <em></em>
              <span>
                <span class="white-space"
                  ><strong>{{ $t('views.auth.join.joinstep1.8360') }}</strong
                  >에 {{ $t('views.auth.join.joinstep1.7263') }}</span
                >
                <span class="terms_text terms_necessary">
                  <strong
                    >{{ $t('views.auth.join.joinstep1.required') }}
                  </strong>
                </span>
              </span>
            </label>
          </div>
          <button class="box_btn line" @click="showTerms">
            <span class="an_t">{{ $t('views.auth.join.joinstep1.361') }}</span>
          </button>
        </li>
        <div v-if="isTerms" class="section terms_wrap" v-html="terms"></div>
        <li>
          <div class="text_label">
            <label>
              <input
                v-model="agreedTerms"
                value="collectAndUse"
                type="checkbox"
                name="agree"
                class="check_agree"
              />
              <em></em>
              <span>
                <span class="white-space">
                  <strong>
                    {{ $t('views.auth.join.joinstep1.6012') }}
                  </strong>
                  {{ $t('views.auth.join.joinstep1.7558') }}
                </span>
                <span class="terms_text terms_necessary">
                  <strong
                    >{{ $t('views.auth.join.joinstep1.required') }}
                  </strong>
                </span>
              </span>
            </label>
          </div>

          <button class="box_btn line" @click="showPrivacy">
            <span class="an_t">{{ $t('views.auth.join.joinstep1.3797') }}</span>
          </button>
        </li>
        <div v-if="isPrivacy" class="section terms_wrap" v-html="privacy"></div>
      </ul>

      <div class="btn_wrap">
        <p class="guide_txt flex-center">
          ※ 회원 전환에 따른 이용 약관 및 개인정보처리방침에 동의해 주셔야 회원
          전환이 완료됩니다.
        </p>
        <div class="tac mt-1">
          <button class="box_btn dull ml" @click="completeAll(false)">
            <span class="an_t">취소</span>
          </button>
          <button
            :disabled="!isValid"
            class="box_btn"
            :class="{ dull: !isValid }"
            @click="completeAll(true)"
          >
            <span class="an_t">{{
              $t('views.auth.join.joinstep1.continue')
            }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from '@/store/axios'
export default {
  name: 'AgreeBox',

  data() {
    return {
      agreedTerms: [],
      checkedAll: false,
      isShowFooter: false,
      terms: '',
      privacy: '',
      isTerms: false,
      isPrivacy: false
    }
  },
  computed: {
    isValid() {
      return !!(
        this.agreedTerms.length > 0 &&
        ['termsOfUse', 'collectAndUse'].every((req) => {
          return this.agreedTerms.includes(req)
        })
      )
    }
  },
  async mounted() {
    const response = await axios.get('/authenticate/MEMBER/terms/')
    this.terms = response.data.result.storeTerms.termsOfUse
    this.privacy = response.data.result.storeTerms.collectAndUse
  },
  methods: {
    checkAll() {
      this.checkedAll = !this.checkedAll
      this.agreedTerms = []

      if (this.checkedAll) {
        this.agreedTerms = ['termsOfUse', 'collectAndUse']
      }
    },
    showTerms() {
      this.isTerms = !this.isTerms
    },
    showPrivacy() {
      this.isPrivacy = !this.isPrivacy
    },
    completeAll(ag) {
      const terms = {
        termsOfUse: true,
        collectAndUse: true
      }
      ag ? this.$emit('setTerms', terms) : this.$emit('setTerms', 'return')
      this.memberTp = 2000
    }
  }
}
</script>
<style src="@/assets/css/page_join.css" scoped></style>
<style lang="scss" scoped>
.wrap {
  width: 100%;
  padding: 0 100px;
}
.box_title {
  border-bottom: 1px solid #0f638f;
  margin: 0;
  padding-bottom: 48px;
}
.cart_st .box_wrap .box {
  width: 100%;
  padding: 0;
}

.section.terms_wrap {
  color: gray;
}
// 왜안되지.,,
.terms_wrap h2 {
  font-size: 1.5rem;
  padding: 0.8rem 0px;
}
.box_wrap .box + .box {
  margin: 0;
}
.cart_st .box_btn.ml {
  margin-right: 10px;
}
.join_check .text_label + .box_btn.line .an_t {
  width: 75px;
  height: 30px;
}
.join_check label {
  align-items: center;
  margin: 20px 0;
  width: calc(100% - 80px);
  display: flex;
  em {
    flex: 0 0 auto;
  }
  > span {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    width: 100%;
    padding-right: 48px;
    .white-space {
      flex: 0 1 auto;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
    .terms_text {
      flex: 0 0 auto;
      margin-top: 0;
      margin-left: 5px;
    }
  }
}
.join_check:not(.check_all) {
  background: #f0f5fa;
  padding: 1px 20px;
  min-height: 60px;
  border-radius: 3px;
}
// .l_box {
//   margin-right: 24px;
// }
@media screen and (max-width: 768px) {
  .wrap {
    width: 100%;
    padding: 0 24px;
  }
  .join_check:not(.check_all) {
    padding: 1px 12px;
  }
}
</style>
